<template>
    <div>
        <div>
            <apexchart width="100%" type="bar" ref="chart" :options="options" :series="series"></apexchart> 
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

var colors = ['#3949AB', '#2196F3'];

  export default {
    components: {
        apexcharts: VueApexCharts
    },      
    props: {
        chartDatas: { type: Object, required: false, default: function () { return {}}},
    },
    watch: {
        
  
    chartDatas : {
        deep: true,
        handler(newValue) {            
            var x = newValue.dates
            var y = newValue.participants    
            var z = newValue.participants_unique  
    
            this.basechart(x, y, z) 
        }
    }}, 
    data: function () {
        return {
            numb : [],
            options : {},
            series : []
        }
     },
     methods : {
        basechart(x, y, z) {   

                this.options = {
                    xaxis: { categories: x },
                    chart: {
                    type: 'bar',
                    height: 400,
                    events: {
                        click: function (event, chartContext, config) {
                            console.log( config)
                        }
                    },
                  },
                colors: colors,

                legend: {
                    position: 'top',
                    horizontalAlign: 'left',
                    offsetX: 40
                }, 
          plotOptions: {
            bar: {
              dataLabels: {
                position: 'top', // top, center, bottom
                rotate: -45,
              },
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val ;
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          }
                }
                this.series = [{
                    name: 'Participations',
                    data: y
                }, {
                    name: 'Joueurs uniques',
                    data: z
                }];

              try {  
                this.$refs.chart.updateSeries(this.series, true);
                this.$refs.chart.updateOptions(this.options, false, true);
            } catch (err) {
                console.log(err)
            }
        }
     }
  }
</script>